export default __webpack_public_path__ + "static/media/bg4.9b517b4c.jpg";